import { getCurrentScope, onScopeDispose, ref } from 'vue';

export const isAbortError = error =>
  error?.name === 'AbortError' ||
  error?.name === 'CanceledError' ||
  error?.code === 'ERR_CANCELED';

export function useAbortableRequest() {
  const isPending = ref(false);
  let controller = null;

  const abort = () => {
    controller?.abort();
    controller = null;
    isPending.value = false;
  };

  const run = async (runner, { onAbort } = {}) => {
    controller?.abort();
    const currentController = new AbortController();
    controller = currentController;
    isPending.value = true;

    try {
      return await runner(currentController.signal);
    } catch (error) {
      if (currentController.signal.aborted || isAbortError(error)) {
        return onAbort;
      }
      throw error;
    } finally {
      if (controller === currentController) {
        controller = null;
        isPending.value = false;
      }
    }
  };

  if (getCurrentScope()) onScopeDispose(abort);

  return { run, abort, isPending };
}
